module.exports = __webpack_public_path__ + "img/1.1.f32e3f25.png";